const getMomentTomorrow = (momentToday) => momentToday.clone().add(1,'days');

export default getMomentTomorrow